import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * @deprecated Este formulario fue reemplazado por el builder de pedidos compartido.
 */
export const TakeawayOrderForm: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/pos/build/takeaway', { replace: true });
  }, [navigate]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 p-6 text-center text-sm text-muted">
      <p>Redirigiendo al nuevo flujo de pedidos para llevar…</p>
      <p>
        Si la redirección no ocurre automáticamente,{' '}
        <button
          type="button"
          onClick={() => navigate('/pos/build/takeaway', { replace: true })}
          className="underline"
        >
          haz clic aquí
        </button>
        .
      </p>
    </div>
  );
};
